<template>
  <div>
    <v-overlay :value="isLoading" color="#036358">
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>
    <v-container v-if="!isLoading" class="mx-auto pa-sm-3 pa-0" style="max-width:100%">
      <v-card
          class="mx-auto elevation-0"
        >
        <v-img style="position: relative"
          height="150"
          :src="this.$http.defaults.baseURL + poster"
          :lazy-src="this.$http.defaults.baseURL + lazyPoster"
          transition="slide-y-transition"
          @click="photoViewer = !photoViewer"
          :class="posterClass"
        >
        </v-img>

        <v-card-title>
          {{service.name}}
          <v-spacer></v-spacer>
          <div v-if="service.idNumber" class="text-caption"><strong>ID / TIN</strong>: {{service.idNumber}}</div>
        </v-card-title>

        <v-card-text>
          <v-row
            align="center"
            class="mx-0"
          >
            <v-rating
              :value="rating"
              color="amber"
              dense
              half-increments
              readonly
              size="14"
            ></v-rating>
            <!-- <div class="grey--text mx-4">4.5 (413)</div> -->
            <div v-if="rating != 0" class="grey--text mx-4">{{rating}} ({{ratingsCount}})</div>
            <div v-if="rating == 0" class="grey--text mx-4">No ratings</div>
            <v-btn
              color="yellow darken-2"
              outlined
              @click="displayRateOverlay()"
              v-if="!this.isMe && !this.exRating"
            >
              Rate
            </v-btn>
            <v-btn
              color="yellow darken-2"
              outlined
              x-small
              @click="displayRateOverlay()"
              v-if="!this.isMe && this.exRating"
            >
              Re-Rate
            </v-btn>
          </v-row>

          <div class="my-4 subtitle-2">
            {{service.area ? service.area.name : ''}} • {{title}}
          </div>

          <div>{{description}}</div>
          <!-- <div v-if="service.idNumber"><strong>ID / TIN Number</strong>: {{service.idNumber}}</div> -->
        </v-card-text>
        <v-card-actions>
          <v-btn
            color="cyan darken-1"
            text
            v-if="!!webSite"
            :href="'https://' + webSite"
            target="_blank"
          >
            Website
          </v-btn>
          <v-btn
            color="teal accent-4"
            text
            v-if="!isMe && !favorite"
            @click="addToFavorites"
          >
            Add to favorites
          </v-btn>
          <v-btn
            color="red lighten-2"
            text
            v-if="!isMe && favorite"
            @click="removeFromFavorites"
          >
            Remove from favorites
          </v-btn>
        </v-card-actions>

        <v-divider class="mx-4"></v-divider>

        <v-card-title>Display phone number</v-card-title>

        <v-card-text>
          <v-btn
            color="deep-purple lighten-2"
            outlined
            large
            block
            v-if="!isPhoneVisible"
            @click="accept"
          >
            Accept & display phone number
          </v-btn>
          <v-btn
            color="green"
            dark
            large
            block
            v-if="isPhoneVisible"
            :href='`tel:${phone}`'
          >
            <v-icon left>
              mdi-phone
            </v-icon>
            {{phone}}
          </v-btn>
          <div
            class="my-4 subtitle-3"
          >
            By clicking this button, I hereby agree to the <a href="/doc/Privacy Policy/fe53405e-2417-46ae-a0ac-146f40b8b38b_en.docx" target="blank">Privacy Policy</a> & <a href="/doc/Terms _ Conditions/93cd00ea-dc93-4bae-8960-863010c65b39_en.docx" target="blank">Terms and Conditions</a>.
          </div>
          <!-- <v-chip-group
            v-model="selection"
            active-class="deep-purple accent-4 white--text"
            column
          >
            <v-chip>5:30PM</v-chip>

            <v-chip>7:30PM</v-chip>

            <v-chip>8:00PM</v-chip>

            <v-chip>9:00PM</v-chip>
          </v-chip-group> -->
        </v-card-text>
        <l-map
          style="height: 480px; width: 100%; z-index: 0;"
          :zoom="zoom"
          :center="coordinates"
          ref="map"
        >
          <l-tile-layer :url="url"></l-tile-layer>
          <l-marker @click="openSheet()" :lat-lng="coordinates">
            <l-tooltip :options="options">{{service.name}}</l-tooltip>
          </l-marker>
        </l-map>
      </v-card>
      <v-overlay :value="overlay">
        <!-- <v-btn
          icon
          @click="overlay = false"
        >
          <v-icon>mdi-close</v-icon>
        </v-btn> -->
        <v-card
          class="elevation-16 mx-auto"
          width="300"
        >
          <v-card-title class="headline">
            Rate Service
          </v-card-title>
          <v-card-text>
            If you enjoy working with {{ service.name }}, please take a few seconds to rate your experience. It really helps!

            <div class="text-center mt-12">
              <v-rating
                v-model="starRating"
                color="yellow darken-3"
                background-color="grey darken-1"
                empty-icon="$ratingFull"
                half-increments
                hover
              ></v-rating>
            </div>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions class="justify-space-between">
            <v-btn text @click="overlay = false">No Thanks</v-btn>
            <v-btn
              color="primary"
              text
              @click="rateService"
            >
              Rate Now
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-overlay>
      <v-overlay :value="snackbar">
        <v-snackbar
          v-model="snackbar"
          timeout="2000"
          shaped
          elevation="24"
          centered
        >
          Thank you for your feedback!
        </v-snackbar>
      </v-overlay>
      <v-btn
        absolute
        bottom
        right
        fab
        class="mb-10"
        @click="center"
      >
        <v-icon color="primary">mdi-map-marker</v-icon>
      </v-btn>
    </v-container>
    <v-overlay :value="!service" color="#036358">
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>
    <v-dialog
      v-model="photoViewer"
      transition="scroll-y-transition"
      overlay-opacity="0.8"
      content-class="no-margin"
    >
      <v-row class="fill-height ma-0">
        <v-img
          :src="this.$http.defaults.baseURL + poster"
          :lazy-src="this.$http.defaults.baseURL + lazyPoster"
        >
          <v-btn
            fab
            absolute
            right
            top
            color="green"
            dark
            small
            class="mt-9"
            @click="photoViewer = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-img>
      </v-row>
    </v-dialog>
    <v-bottom-sheet v-model="sheet">
      <v-sheet
        class="text-center"
        height="230px"
      >
        <div class="pt-6 pb-4"><strong>{{service.name}}</strong></div>
        <v-btn
          class="mt-4 px-15"
          color="green"
          dark
          @click="navigate()"
          large
        >
          Get Directions
        </v-btn>
      </v-sheet>
    </v-bottom-sheet>
    <v-overlay :value="guestOverlay" :dark="false">
      <v-card class="elevation-16 mx-auto text-center" width="300">
        <v-card-title class="title text-center justify-center">You must</v-card-title>
        <v-card-text>
          <v-btn to="/" block depressed dark color="green" style="font-size:16px" large>Register</v-btn>
          <div class="title mt-2">to {{guestText}}</div>
        </v-card-text>
        <v-card-actions>
          <v-btn color="red" text block @click="guestOverlay = false">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-overlay>
  </div>
</template>

<script>
import { LMap, LTileLayer, LMarker, LTooltip } from 'vue2-leaflet'

import { mapGetters } from 'vuex'

export default {
  components: {
    LMap,
    LTileLayer,
    LMarker,
    LTooltip
  },
  props: ['id'],
  data () {
    return {
      url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
      zoom: 16,
      bounds: null,
      overlay: false,
      snackbar: false,
      isPhoneVisible: false,
      starRating: 5,
      options: {
        permanent: true
      },
      photoViewer: false,
      isLoading: false,
      guestOverlay: false,
      guestText: '',
      sheet: false
    }
  },
  methods: {
    openSheet () {
      this.sheetTitle = this.service.name
      this.sheet = !this.sheet
    },
    navigate () {
      const { location } = this.service
      this.sheet = false
      const URL = `https://www.google.com/maps/dir/?api=1&travelmode=driving&destination=${location.coordinates[0]},${location.coordinates[1]}`
      window.open(URL, '_blank')
    },
    center () {
      this.$refs.map.mapObject.setView(this.coordinates, this.zoom)
    },
    displayRateOverlay () {
      if (this.guestMode) {
        this.guestText = 'rate'
        this.guestOverlay = true
        return
      }

      this.overlay = !this.overlay
    },
    async rateService () {
      this.overlay = false

      try {
        await this.$store.dispatch('rateService', this.starRating)
      } catch (e) {
        console.log(e)
      }

      this.snackbar = true
    },
    accept () {
      if (this.guestMode) {
        this.guestText = 'display phone number'
        this.guestOverlay = true
        return
      }

      this.isPhoneVisible = true
    },
    async addToFavorites () {
      try {
        if (this.guestMode) {
          this.guestText = 'add to favorites'
          this.guestOverlay = true
          return
        }

        this.$store.commit('setFavorite', !this.favorite)
        await this.$store.dispatch('addToFavorites', this.service._id)
      } catch (e) {
        console.log(e)
      }
    },
    async removeFromFavorites () {
      try {
        this.$store.commit('setFavorite', !this.favorite)
        await this.$store.dispatch('removeFromFavorites', this.service._id)
      } catch (e) {
        console.log(e)
      }
    },
    zoomUpdated (zoom) {
      this.zoom = zoom
    },
    centerUpdated (center) {
      this.center = center
    },
    boundsUpdated (bounds) {
      this.bounds = bounds
    },
    async fetchService () {
      this.isLoading = true
      let { id } = this
      if (!id) {
        id = this.$route.params.id
      }

      if (!this.guestMode) {
        await this.$store.dispatch('getServiceById', id)
      } else {
        await this.$store.dispatch('getServiceGuestById', id)
      }

      this.starRating = this.rating
      this.isLoading = false
    }
  },
  watch: {
    id: function () {
      this.fetchService()
    }
  },
  computed: {
    ...mapGetters(['service', 'poster', 'lazyPoster', 'title', 'description', 'webSite', 'phone', 'coordinates', 'rating', 'favorite', 'isMe', 'exRating', 'ratingsCount', 'guestMode']),
    canRate () {
      if (this.isMe) {
        return false
      }

      if (this.rating) return false

      return true
    },
    posterClass () {
      if (!this.$vuetify.theme.dark) return
      if (this.poster.indexOf('placeholder') === -1) return
      return 'dark-invert'
    }
    // canAddToFavorites () {
    //   if (this.isMe) {
    //     return false
    //   }

    //   return true
    // }
  },
  mounted () {
    this.fetchService()
    // if (!this.service.isService) {
    //   this.$router.push('search')
    // }
  }
}
</script>

<style>
.dark-invert .v-image__image {
  filter: invert(0.885)
}
</style>
